// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/angular-calendar.scss
// module id = 15
// module chunks = 0